import React from "react"
import { Col, Container, Row, Spinner } from "reactstrap"

//actions
import MetaTag from "components/Common/Meta-tag"
import { useSelector } from "react-redux"
import AllInspections from "pages/Inspection/DatatableTables"

const InspectionDashboard = () => {
  const { loading } = useSelector(state => ({
    dashboardData: state.Dashboard.dashboardData,
    loading: state.Dashboard.loading,
  }))
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTag title="Dashboard" />
        <Container fluid>
          {loading ? (
            <Spinner color="secondary" className="d-block m-auto" />
          ) : (
            <div className="container-fluid">
              <Row>
                <Col className="col-12">
                  <AllInspections dashboard="dashboard" />
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InspectionDashboard
